module.exports = __webpack_public_path__ + "img/thumbs-up-icon.29ac1c6c.svg";